import styled from "styled-components";
import { ThemePalette } from "../../../../theme";

export const Action = styled.div`
  form {
    width: 250px;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
`;

export const Sheet = styled.div`
  background-color: ${ThemePalette.colorWhite};
  border-radius: 6px;
  padding: 16px 18px;
  // margin-bottom: 1rem;
  width: 100%;
  filter: drop-shadow(0 4px 3px ${ThemePalette.colorPrimary}10)
    drop-shadow(0 2px 2px ${ThemePalette.colorPrimary}20);
  h4 {
    font-size: 1.2rem;
    font-weight: 500;
  }
  h3 {
    font-size: 0.8rem;
    font-weight: 500;
    margin-bottom: 0.3rem;
  }
  .ant-tag {
    margin: 0;
  }
  .grab {
    cursor: grab;
  }
`;

export const Details = styled.div<{ count: number; isHorizontal: boolean }>`
  background-color: #f5f5f5;
  border-radius: 6px;
  padding: 10px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: table;
  h1 {
    font-size: 1.5rem;
    font-weight: 500;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
  .column-container {
    align-self: stretch;
    padding: 12px;
    border: 1px dashed transparent;
    transition: border-color 0.3s;
  }
  ${({ count, isHorizontal }) =>
    count > 2
      ? `
    .column-container:first-child {
    ${isHorizontal ? "border-right: 0;" : "border-botton: 0;"}
    }
    .column-container:nth-child(${count}) {
      ${isHorizontal ? "border-left: 0;" : "border-top: 0;"}
    }
    `
      : ""}
  &:has(.dragging) .column-container {
    border-color: #1890ff;
  }
`;
